module.exports = "../images/fishing-v2.jpg?v=cb2c78d";